export const ROOT = "/";
export const POSTLOGINLANDING = "/postLoginLanding"
export const PRIVACY = "/privacy"

export const FAQ = "/faq"
export const CONTATTI = "/contatti"
export const LOGIN = "/login";

export const PROFILO = "/profilo"
export const CAMPAGNE = "/campagne";
export const ESITI = "/esiti"
export const ESITICL = "/esiti-colonretto"


export const SCREENINGCOLONRETTO = "/screening-colonretto";
export const INFOCOLONRETTO = "/info-colonretto";
export const INVITISOLLECITICL = "/inviti-solleciti-colonretto";
export const DETTAGLIOINVITOSOLLECITOCL = "/dettaglio-invitosollecito"
export const RIFIUTOCL = "/rifiuto-colonretto"
export const STRUTTURE = "/strutture"
export const DOMICILIO = "/domicilio"
export const RICEVIADOMICILIO = "/ricevi-a-domicilio"
export const MODIFICAINDIRIZZOSPEDIZIONE = "/modifica-indirizzo-spedizione"

export const ADESIONECL = "/adesione-colonretto"

export const SCREENINGMAMMOGRAFICO = "/screening-mammografico";
export const INFOMAMMOGRAFICO = "/info-mammografico";

export const PAGENOTFOUND = "*";
/*

export const INVITI_E_SOLLECITI = "/inviti-e-solleciti";

export const SCREENING_ADESIONE = "/screening-adesione";
export const SCREENING_RIFIUTO = "/screening-rifiuto";
export const STRUTTURE = "/strutture";
export const INDIRIZZO = "/domicilio";
export const MESSAGGIO = "/messaggio/"

export const CANDIDATURASPONTANEACOLONRETTO = "/candidaturaspontanea-colonretto"
export const MAMMOGRAFICO = "/mammografico";
export const GESTIONEAPPUNTAMENTI = "/gestione-appuntamenti";
export const SPOSTAAPPUNTAMENTO = "/sposta-appuntamento";





*/
